import { ReportState } from 'src/modules/report/types/ReportState';
import { RootState } from 'src/types/RootState';

export function getReportState(state: RootState): ReportState {
  return state.report;
}
